export default __webpack_public_path__ + "static/media/BloinxFinal.377bfb4f.svg";